<template>
    <div class="dropdown">
        <div class="dropdown-selected" @click="is_open = !is_open">{{ selected.name || title }}</div>
        <div class="dropdown-block" v-if="is_open">
            <div class="dropdown-block_item"
                 v-for="(item, key) in dropdownData"
                 :key="key"
                 @click="setSelected(item)"
            > {{ item.name }}</div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "Dropdown",
        props: {
            dropdownData: {
                type: Array,
                default: () => {}
            },
            title: {
                type: String,
                default: ''
            }
        },
        data() {
            return {
                selected: {
                    name: ''
                },
                is_open: false
            }
        },
        methods: {
            setSelected(val) {
                this.selected = val;
            }
        }
    };
</script>

<style scoped lang="scss">
    .dropdown {
        width: 100%;
        position: relative;
        font-size: 14px;
        line-height: 21px;
        color: #4A505E;
        &-selected {
            border: 1px solid #D8DDE4;
            border-radius: 5px;
            padding: 8px 40px 8px 16px;
        }
        &-block {
            background-color: #FCFCFC;
            border: 1px solid #D8DDE4;
            border-radius: 5px;
            position: absolute;
            width: 100%;
            padding: 8px 16px;
            top: 105%;

            &_item {
                padding: 8px 0;
            }
        }
    }
</style>
